import { Page } from "@repobit/dex-utils";
import { UserDataCompleteUserObject, UserDataObject } from "./typeDefinitions";

export class UserDetectedEvent {
  event = 'user detected' as const;
  user: UserDataCompleteUserObject;

  constructor();
  constructor(page: Page, userData: UserDataObject);
  constructor(page?: Page, userData?: UserDataObject) {
    if (page && userData) {
      const emarsysID = page.getParamValue('ems-uid') || page.getParamValue('sc_uid') || undefined;

      this.user = {
        loggedIN: userData.ID ? true : false
      }

      if (userData.ID) {
        this.user.ID = userData.ID;
      }

      if (userData.visitorID) {
        this.user.visitorID = userData.visitorID;
      }

      if (emarsysID) {
        this.user.emarsysID = emarsysID;
      }

      if (userData.productFinding) {
        this.user.productFinding = userData.productFinding;
      }
    } else {
      // find the existing user detected entry
      const existingUserDetectedEvent = window.adobeDataLayer.find(adobeDataLayerEntry =>
        adobeDataLayerEntry.event === 'user detected'
      ) as UserDetectedEvent;

      if (existingUserDetectedEvent) {
        this.user = { ...existingUserDetectedEvent.user };
      } else {
        this.user = { loggedIN: false }
      }
    }
  }
}